import { Box, BoxProps } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React, { ReactNode } from 'react'

type Props = {
  children: ReactNode
  backgroundColor?: 'marine' | 'primaryMarine' | 'white' | 'lightGray'
  contentsMaxWidth?: 'full' | 'large'
  contentsPaddingY?: 'none' | 'medium' | 'large'
  sx?: BoxProps['sx']
}

export const Section: React.FC<Props> = ({
  children,
  backgroundColor = 'white',
  contentsMaxWidth = 'large',
  contentsPaddingY = 'medium',
  sx,
}) => {
  const MuiTheme = useTheme()
  const backgroundColorMap = {
    marine: {
      backgroundColor: MuiTheme.palette.background.marine,
    },
    primaryMarine: {
      backgroundColor: MuiTheme.palette.primary.main,
    },
    white: {
      backgroundColor: MuiTheme.palette.background.default,
    },
    lightGray: {
      backgroundColor: MuiTheme.palette.background.lightGray,
    },
  }
  const contentsMaxWidthMap = {
    full: '100%',
    large: 1200,
  }
  const contentsPaddingYMap = {
    none: 0,
    medium: 8,
    large: 12,
  }

  return (
    <Box
      component="section"
      sx={{
        backgroundColor: backgroundColorMap[backgroundColor],
        ...sx,
      }}
    >
      <Box
        sx={{
          mx: 'auto',
          py: contentsPaddingYMap[contentsPaddingY],
          px: { xs: 2, lg: 0 },
          maxWidth: { lg: contentsMaxWidthMap[contentsMaxWidth] },
        }}
      >
        {children}
      </Box>
    </Box>
  )
}
